import { Component, signal } from '@angular/core';

@Component({
    selector: 'lokos-faq',
    templateUrl: './faq.component.html',
    styleUrl: './faq.component.scss',
    standalone: false,
})
export class FaqComponent {
    breadcrumbs = signal([
        { label: 'Home', link: '/main/dashboard/home' },
        { label: 'FAQs' },
    ]);
}
